// Single source of truth for the sidebar navigation entries. Used by Sidebar (to render the nav)
// and by the UI-context bridge (to tell SAM which nav options the user can see).
export interface NavItem {
  label: string;
  /** Omit `path` to render a name-only label (page not yet built). */
  path?: string;
}

// Only built pages are shown for now. The following name-only placeholders are intentionally
// hidden from the UI until their pages exist — re-add them here when ready:
//   Dashboard, Transactions, Proposals, Jobs, Calendar, Billing.
// Properties (+ its Engagements/workflow drill-down) has real pages under src/pages/properties/,
// but by product convention tenant users navigate through chat only — SAM opens the Property/
// Workflow card in-workspace (see A.OPEN_WORKFLOW_PANEL / A.OPEN_ENGAGEMENTS_PANEL in
// app.domain.workflows.agent_tools) rather than a sidebar link. Do not add a nav entry here.
// Communications has NO standalone page — SAM handles all drafting/sending in chat (the compose
// card); the /communications page + route were removed.
export const tenantNavItems: NavItem[] = [
  { label: 'Chat', path: '/chat' },
];

export const platformNavItems: Array<NavItem & { path: string }> = [
  { label: 'Chat', path: '/chat' },
  { label: 'Tenants', path: '/platform/tenants' },
  { label: 'Users', path: '/platform/users' },
  { label: 'Plans', path: '/platform/plans' },
  { label: 'AI Agents', path: '/platform/agents' },
  { label: 'Configurations', path: '/platform/configurations' },
  { label: 'SAM Prompts', path: '/platform/sam-prompts' },
  { label: 'Session Logs', path: '/platform/session-logs' },
  { label: 'Chat Monitor', path: '/platform/chat-monitor' },
  { label: 'Notifications', path: '/notifications' },
  { label: 'Notification Management', path: '/platform/notifications' },
  { label: 'Queue Management', path: '/platform/queues' },
  { label: 'Scheduled Triggers', path: '/platform/scheduler-events' },
  { label: 'Workflows', path: '/platform/workflows' },
];

/** Nav entries visible to the current user. Tenant users also get a Settings entry (rendered in
 *  the sidebar footer) — included here so the situational-awareness snapshot reflects it. */
export function getNavItems(isPlatformRole: boolean): NavItem[] {
  return isPlatformRole
    ? platformNavItems
    : [...tenantNavItems, { label: 'Settings', path: '/settings/tenant' }];
}
